import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { authApi } from "../api/api";
import { localizeAuthErrorMessage } from "../utils/authErrorMessages";
import "./Login.css";

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    const normalizedUsername = username.trim();
    const normalizedPassword = password.trim();

    if (!normalizedUsername || !normalizedPassword) {
      setErrorMessage("نام کاربری و رمز عبور الزامی است.");
      return;
    }

    setIsSubmitting(true);
    setErrorMessage("");

    try {
      await authApi.login({
        username: normalizedUsername,
        password: normalizedPassword,
      });
      navigate("/dashboard");
    } catch (error) {
      const localizedMessage = localizeAuthErrorMessage(error?.message, "ورود ناموفق بود. لطفا دوباره تلاش کنید.");
      setErrorMessage(localizedMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1 className="login-title">خبر خوان</h1>
        <form className="login-form" onSubmit={handleSubmit}>
          <input
            type="text"
            className="login-input"
            placeholder="نام کاربری"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
          />
          <input
            type="password"
            className="login-input"
            placeholder="رمز عبور"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />

          <button type="submit" className="login-button" disabled={isSubmitting}>
            {isSubmitting ? (
              <span className="login-progress" aria-label="در حال پردازش">
                <span className="login-progress-track">
                  <span className="login-progress-bar" />
                </span>
              </span>
            ) : (
              "ورود"
            )}
          </button>

          <p className={`login-feedback ${errorMessage ? "is-visible" : ""}`} aria-live="polite">
            {errorMessage || " "}
          </p>
        </form>
      </div>
    </div>
  );
};

export default Login;
